import { render, staticRenderFns } from "./PartAAndBOverview.vue?vue&type=template&id=874eac36&lang=pug"
import script from "./PartAAndBOverview.vue?vue&type=script&lang=js"
export * from "./PartAAndBOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports